import { Col, Container, Form, Modal, Row, Tab, Tabs } from "react-bootstrap";
import { MonthlySearch } from "./Controls/MonthlySearch";
import { HourlySearch } from "./Controls/HourlySearch";
import { useNavigate, useLoaderData, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useAtom } from "jotai";
import { HourlyForm, MonthlyForm, hourlyFormAtom, monthlyFormAtom, tabAtom, SearchActivity, createHourlyForm, createMonthlyForm } from "./Data/Atoms";
import { Button } from "./Controls/Button";
import { Content } from "./Controls/Content";
import { Operator } from "./Data/ApiTypes";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

interface ResetSubmitProps {
    reset:  () => void;
    submit: () => void;
}

function ResetSubmit( props: ResetSubmitProps ) {
    return <Container fluid>
        <Row>
            <Col xs="6">
                <Button
                    type="button"
                    className="w-100"
                    onClick={props.reset}>
                    Today
                </Button>
            </Col>
            <Col xs="6">
                <Button
                    type="submit"
                    onClick={props.submit}                   
                    className="w-100 btn-main">
                    Search
                </Button>
            </Col>
        </Row>
    </Container>;
}

export function LandingPage() {
    const [ tab,     setTab     ] = useAtom( tabAtom         );
    const [ hourly,  setHourly  ] = useAtom( hourlyFormAtom  );
    const [ monthly, setMonthly ] = useAtom( monthlyFormAtom );
    const [place, setPlace] = useState<{
        viewport: {
            north: number;
            south: number;
            east: number;
            west: number;
        };
        name: string;
        formatted_address: string;
    } | null>(null);
    const [showInvalidInviteModal, setShowInvalidInviteModal] = useState(false);
    const op = useLoaderData() as Operator;

    const { register: regHr, control: controlHr, getValues: getValuesHr, reset: resetHr, watch: watchHr, setValue: setValueHr,
            handleSubmit: handleSubmitHr, formState: formStateHr } = useForm<HourlyForm>(  { defaultValues: hourly  } );

    const { register: regMo, control: controlMo, getValues: getValuesMo, reset: resetMo, watch: watchMo, setValue: setValueMo,
        handleSubmit: handleSubmitMo, formState: formStateMo } = useForm<MonthlyForm>( { defaultValues: monthly } );

    const vals = getValuesHr();
    const nav = useNavigate();

    const [searchParams] = useSearchParams();
    const error = searchParams.get("error");
    useEffect(() => {
        if (error === "inviteExpired") {
        setShowInvalidInviteModal(true);

        const newUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, "", newUrl);
        }
    }, [error]);

    function reset() {
        setHourly(  { ...createHourlyForm(), location: getValuesHr("location") } );
        resetHr(    { ...createHourlyForm(), location: getValuesHr("location") } );

        setMonthly( { ...createMonthlyForm(), location: getValuesMo("location") } );
        resetMo(    { ...createMonthlyForm(), location: getValuesMo("location") } );
    }

    function handlePlaceSelect(p: google.maps.places.Place | null) {
        if (p?.viewport) {
            setPlace({
                viewport: {
                    north: p.viewport.getNorthEast().lat(),
                    south: p.viewport.getSouthWest().lat(),
                    east: p.viewport.getNorthEast().lng(),
                    west: p.viewport.getSouthWest().lng()
                },
                name: p.displayName || '',
                formatted_address: p.formattedAddress || ''
            });
        } else {
            setPlace(null);
        }
    }

    function submitHr() {
        const formData = getValuesHr();
        setHourly(formData);
        nav("results", { state: { place: place } });
        return;
    }

    function submitMo() {
        const formData = getValuesMo();
        setMonthly(formData);
        nav("results", { state: { place: place } });
    }

    return <Content fluid
                    id="landing-page"
                    className="fullheight g-0 g-sm-1">
        <Row className="fullheight justify-content-sm-center g-0">
            <Col sm="10" md="8" lg="6" xl="4"
                 className="fullheight d-flex align-items-top align-items-md-center "
                 style={{ minWidth: "40%" }}>
                <div id="landing-page-window" className="w-100 p-4 py-5 shadow-lg-3 rounded-4 border-primary-0 border-primary-lg-2">
                    <img width="150"
                         src={op.logoUrl}
                         alt={op.name + " Logo"}
                         className="m-4"
                         style={{ justifySelf: "center" }} />
                    <Tabs defaultActiveKey="hourly"
                          activeKey={tab}
                          onSelect={k => setTab( k as SearchActivity )}
                          className="mb-3 w-100"
                          variant="underline"
                          justify>
                        <Tab eventKey="hourly" title="Hourly" onClick={() => setTab( SearchActivity.Hourly )}>
                            <Form noValidate onSubmit={handleSubmitHr(submitHr)}>
                                <HourlySearch
                                    register={regHr}
                                    watch={watchHr}
                                    control={controlHr}
                                    setValue={setValueHr}
                                    errors={formStateHr.errors}
                                    setPlace={handlePlaceSelect} />
                                <div className="mt-3">
                                </div>
                                <ResetSubmit reset={reset}
                                             submit={ () => {} } />
                            </Form>
                        </Tab>
                        <Tab eventKey="monthly" title="Monthly" onClick={() => setTab( SearchActivity.Monthly )}>
                            <Form noValidate onSubmit={handleSubmitMo(submitMo)}>
                                <MonthlySearch
                                    register={regMo}
                                    watch={watchMo}
                                    control={controlMo}
                                    setValue={setValueMo}
                                    errors={formStateMo.errors}
                                    setPlace={handlePlaceSelect} />
                                <ResetSubmit reset={reset}
                                             submit={ () => {} } />
                            </Form>
                        </Tab>
                    </Tabs>
                </div>
            </Col>
        </Row>
      <Modal show={showInvalidInviteModal} onHide={() => setShowInvalidInviteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Invalid Link</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          The link you followed is no longer valid or has expired.
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-main" onClick={() => setShowInvalidInviteModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </Content>;
}